module.exports = __webpack_public_path__ + "img/mark_as_rejected_disabled.c708830f.svg";